import { render, staticRenderFns } from "./SolutionDetails.vue?vue&type=template&id=72383d46&"
import script from "./SolutionDetails.vue?vue&type=script&lang=js&"
export * from "./SolutionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports